import { Button, Typography, WithStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { isNil } from "lodash";
import * as moment from "moment";
import * as React from "react";
import { addressProofItems, customerFamilyStatusItems, customerTitleItems, idDocumentItems } from "../../config";
import { theme } from "../../theme/theme";
import { Customer } from "../../types/Customer";
import { Form } from "../../types/Form";
import { UiFormBuilder } from "../../utils/UiFormBuilder";
import { UpdateRequestBuilder } from "../../utils/UpdateRequestBuilder";
import { required } from "../../validators";
import InputCheckbox from "../InputCheckbox/InputCheckbox";
import InputCustomerAutocomplete from "../InputCustomerAutocomplete/InputCustomerAutocomplete";
import InputDate from "../InputDate/InputDate";
import InputEmail from "../InputEmail/InputEmail";
import InputPhone from "../InputPhone/InputPhone";
import InputRadio from "../InputRadio/InputRadio";
import InputSelect from "../InputSelect/InputSelect.component";
import InputText from "../InputText/InputText";
import { quotationFormStyles } from "./QuotationForm.styles";
import { ProductName } from "../../types/Products";

interface QuotationFormCustomerProps extends WithStyles<typeof quotationFormStyles> {
    productName: ProductName;
    customers?: Customer[];
    customer: Customer;
    onChange(customer: Customer, isCustomerModifiedOrNew?: boolean);
}

type QuotationFormCustomerState = {
    form: Form<Customer>;
};

class QuotationFormCustomer extends React.Component<QuotationFormCustomerProps, QuotationFormCustomerState> {
    private formBuilder = null;

    /**
     *
     */
    componentWillMount() {
        this.updateState(this.props);
    }

    /**
     *
     */
    componentWillReceiveProps(nextProps: QuotationFormCustomerProps) {
        this.updateState(nextProps);
    }

    /**
     *
     * @param {string} fieldName
     * @param value
     */
    public onChange(fieldName: string, value: any) {
        const builder = new UpdateRequestBuilder();
        builder.set(`values.${fieldName}`, value);
        let form = builder.exec(this.state.form);
        this.setState({ form: form });
        this.props.onChange(form.values, true);
    }

    /**
     *
     * @returns {any}
     */
    public render() {
        if (!this.state) {
            return null;
        }

        const uiForm = this.formBuilder.build(this.state.form);
        const { classes, customers } = this.props;

        return (
            <div className={classes.box}>
                {this.props.productName && this.renderTitleSection(classes, customers)}
                {this.props.customer && (
                    <Grid container={true} spacing={16} style={{ paddingTop: 20 }}>
                        <Grid item={true} sm={12} style={{ paddingBottom: 10 }}>
                            <InputRadio {...uiForm.fields.title} />
                        </Grid>

                        <Grid item={true} sm={4} style={{ paddingTop: 0 }}>
                            <InputText {...uiForm.fields.lastname} />
                        </Grid>
                        <Grid item={true} sm={4} style={{ paddingTop: 0 }}>
                            <InputText {...uiForm.fields.firstname} />
                        </Grid>

                        {!this.props.productName || this.props.productName === "GPI" ? (
                            <>
                                <Grid item={true} sm={4} style={{ paddingTop: 0 }}>
                                    <InputSelect {...uiForm.fields.familyStatus} />
                                </Grid>
                                <Grid item={true} sm={4}>
                                    <InputText {...uiForm.fields.birthname} />
                                </Grid>
                            </>
                        ) : (
                            <>
                                <Grid item={true} sm={4} style={{ paddingTop: 0 }}>
                                    <InputText {...uiForm.fields.birthname} />
                                </Grid>
                            </>
                        )}

                        <Grid item={true} sm={4}>
                            <InputDate {...uiForm.fields.birthdate} />
                        </Grid>
                        <Grid item={true} sm={4}>
                            <InputText {...uiForm.fields.cityOfBirth} />
                        </Grid>

                        {!this.props.productName || this.props.productName === "GPI" ? (
                            <Grid item={true} sm={4}>
                                <InputText {...uiForm.fields.departmentOfBirth} />
                            </Grid>
                        ) : null}

                        <Grid item={true} sm={4}>
                            <InputText {...uiForm.fields.countryOfBirth} />
                        </Grid>

                        <Grid item={true} sm={12}>
                            <InputText {...uiForm.fields.address} />
                        </Grid>

                        <Grid item={true} sm={4}>
                            <InputText {...uiForm.fields.zipcode} />
                        </Grid>
                        <Grid item={true} sm={4}>
                            <InputText {...uiForm.fields.city} />
                        </Grid>
                        <Grid item={true} sm={4}>
                            <InputPhone {...uiForm.fields.phone} />
                        </Grid>

                        {!this.props.productName || this.props.productName === "GPI" ? (
                            <>
                                <Grid item={true} sm={4}>
                                    <InputPhone {...uiForm.fields.mobile} />
                                </Grid>
                                <Grid item={true} sm={8}>
                                    <InputText {...uiForm.fields.vocation} />
                                </Grid>
                                <Grid item={true} sm={12}>
                                    <InputEmail {...uiForm.fields.email} />
                                </Grid>
                            </>
                        ) : (
                            <>
                                <Grid item={true} sm={4}>
                                    <InputPhone {...uiForm.fields.mobile} />
                                </Grid>
                                <Grid item={true} sm={8}>
                                    <InputEmail {...uiForm.fields.email} />
                                </Grid>
                            </>
                        )}

                        <Grid item={true} sm={12}>
                            <InputCheckbox {...uiForm.fields.optin} />
                        </Grid>
                    </Grid>
                )}
                {this.props.customer && this.props.productName === "GO" ? (
                    <Grid container={true} spacing={16} style={{ marginTop: theme.spacing.unit * 4 }}>
                        <Grid item={true} sm={12}>
                            <InputRadio {...uiForm.fields.idDocument} />
                        </Grid>
                        <Grid item={true}>
                            <InputRadio {...uiForm.fields.addressProof} />
                        </Grid>
                        <Grid item={true} style={{ alignSelf: "center", marginTop: "8px" }}>
                            <InputText {...uiForm.fields.addressProofOther} />
                        </Grid>
                    </Grid>
                ) : null}
                {this.props.customer && this.props.productName === "SPR" ? (
                    <Grid container={true} sm={12} style={{ marginTop: theme.spacing.unit * 4 }}>
                        <Grid item={true} sm={12}>
                            <InputRadio {...uiForm.fields.idDocument} />
                        </Grid>
                    </Grid>
                ) : null}

                {this.props.customer && (
                    <Grid item={true} sm={12} style={{ paddingTop: "10px" }}>
                        <Typography variant="caption">* Merci de remplir les champs obligatoires</Typography>
                    </Grid>
                )}
            </div>
        );
    }

    public renderTitleSection(classes, customers: Customer[]) {
        return (
            <Grid container={true} spacing={16}>
                <Grid item={true} sm={12}>
                    <Typography variant="title" gutterBottom={true} className={classes.formTitle}>
                        2/ Situation de l'adhérent
                    </Typography>
                </Grid>
                {customers ? (
                    <>
                        <Grid item={true} sm={4}>
                            <InputCustomerAutocomplete
                                autocompleteCustomers={customers}
                                onChange={this.onInputCustomerAutocompleteChange.bind(this)}
                                placeholder="Recherche un client..."
                            />
                        </Grid>
                        <Grid item={true} sm={2}>
                            <Typography style={{ textAlign: "center" }} variant="title">
                                ou
                            </Typography>
                        </Grid>
                        <Grid item={true} sm={4}>
                            <Button
                                style={{
                                    width: "12rem",
                                    borderRadius: "0px",
                                    borderColor: "#31190c",
                                }}
                                onClick={this.onCreateNewCustomer.bind(this)}
                                variant="outlined"
                                color="primary"
                                size="small"
                            >
                                Nouveau Client
                            </Button>
                        </Grid>
                    </>
                ) : null}
            </Grid>
        );
    }

    private onCreateNewCustomer() {
        const customer = Customer.createNew({
            quotations: {},
        });
        this.props.onChange(customer);
    }

    /**
     *
     * @param customer
     * @param element
     */
    private onInputCustomerAutocompleteChange(customer: Customer, element: any) {
        this.props.onChange(customer);
    }

    private getMaxDateForProduct(productName: ProductName) {
        if (productName === "GPI")
            return moment()
                .subtract(18, "year")
                .date(31)
                .month(11)
                .format("YYYY-MM-DD");
        return moment()
            .subtract(18, "year")
            .format("YYYY-MM-DD");
    }

    /**
     *
     * @param props
     */
    private updateState(props: QuotationFormCustomerProps) {
        const existingCustomer: Customer =
            props.customer && props.customers ? props.customers.find((c) => c.id === props.customer.id) : null;

        this.formBuilder = new UiFormBuilder<Customer>()
            .addField("title", {
                props: {
                    name: "title",
                    items: customerTitleItems,
                    disabled: !isNil(existingCustomer) && !isNil(existingCustomer.title),
                    required: true,
                },
            })
            .addField("firstname", {
                props: {
                    label: "Prénom",
                    placeholder: "Prénom",
                    disabled: !isNil(existingCustomer) && !isNil(existingCustomer.firstname),
                    required: true,
                },
            })
            .addField("lastname", {
                props: {
                    label: "Nom",
                    placeholder: "Nom",
                    disabled: !isNil(existingCustomer) && !isNil(existingCustomer.lastname),
                    required: true,
                },
            })
            .addField("familyStatus", {
                props: {
                    label: "Situation de famille",
                    placeholder: "Situation de famille",
                    items: customerFamilyStatusItems,
                    disabled: !isNil(existingCustomer) && !isNil(existingCustomer.familyStatus),
                    required: true,
                },
            })
            .addField("birthname", {
                props: {
                    label: "Nom de naissance",
                    placeholder: "Nom",
                    disabled: !isNil(existingCustomer) && !isNil(existingCustomer.birthname),
                    required: !props.customer || !props.customer.title || props.customer.title !== "mr",
                },
            })
            .addField("birthdate", {
                props: {
                    label: "Date de naissance",
                    disabled: !isNil(existingCustomer) && !isNil(existingCustomer.birthdate),
                    required: true,
                    dateProps: {
                        min: moment()
                            .subtract(100, "year")
                            .format("YYYY-MM-DD"),
                        max: this.getMaxDateForProduct(this.props.productName),
                    },
                },
            })
            .addField("cityOfBirth", {
                props: {
                    label: "Code postal et ville de naissance",
                    placeholder: "CP + Ville",
                    disabled: !isNil(existingCustomer) && !isNil(existingCustomer.cityOfBirth),
                },
            })
            .addField("departmentOfBirth", {
                props: {
                    label: "Département de naissance",
                    placeholder: "Département",
                    disabled: !isNil(existingCustomer) && !isNil(existingCustomer.departmentOfBirth),
                },
            })
            .addField("countryOfBirth", {
                props: {
                    label: "Pays de naissance",
                    placeholder: "Pays",
                    disabled: !isNil(existingCustomer) && !isNil(existingCustomer.countryOfBirth),
                },
            })
            .addField("address", {
                props: {
                    label: "Adresse",
                    placeholder: "Adresse",
                    disabled: !isNil(existingCustomer) && !isNil(existingCustomer.address),
                    required: true,
                },
            })
            .addField("zipcode", {
                props: {
                    label: "Code postal",
                    placeholder: "Code postal",
                    disabled: !isNil(existingCustomer) && !isNil(existingCustomer.zipcode),
                    required: true,
                },
            })
            .addField("city", {
                props: {
                    label: "Ville",
                    placeholder: "Ville",
                    disabled: !isNil(existingCustomer) && !isNil(existingCustomer.city),
                    required: true,
                },
            })
            .addField("phone", {
                props: {
                    label: "Téléphone",
                    placeholder: "ex. 01 01 01 01 01",
                    legend: "+334 93 55 01 01 (pour l'international)",
                    disabled: !isNil(existingCustomer) && !isNil(existingCustomer.phone),
                },
            })
            .addField("mobile", {
                props: {
                    label: "Portable",
                    placeholder: "ex. 06 01 01 01 01",
                    disabled: !isNil(existingCustomer) && !isNil(existingCustomer.mobile),
                    legend: "+334 93 55 01 01 (pour l'international)",
                },
            })
            .addField("vocation", {
                props: {
                    label: "Profession",
                    disabled: !isNil(existingCustomer) && !isNil(existingCustomer.vocation),
                    placeholder: "Profession",
                },
            })
            .addField("email", {
                props: {
                    label: "Email",
                    placeholder: "Email",
                    disabled: !isNil(existingCustomer) && !isNil(existingCustomer.email),
                },
            })
            .addField("optin", {
                props: {
                    label:
                        "Je souhaite recevoir des emails d'information sur les offres produits et services du Groupe AG2R LA MONDIALE " +
                        "(je peux à tout moment modifier mes préférences sur simple demande)",
                },
            })
            .addField("idDocument", {
                props: {
                    label:
                        "Vous devez joindre au présent bulletin d'adhésion la photocopie recto/verso de votre pièce d'identité :",
                    items: idDocumentItems,
                    required: true,
                },
            })
            .addField("addressProof", {
                props: {
                    label: "Ainsi qu'un justificatif de domicile de moins de 3 mois :",
                    items: addressProofItems,
                    required: true,
                },
            })
            .addField("addressProofOther", {
                props: {
                    placeholder: "précisez",
                    disabled: props.customer ? props.customer.addressProof !== "other" : true,
                    required: props.customer ? props.customer.addressProof === "other" : false,
                },
            })
            .onChange(this.onChange.bind(this));

        this.setState({
            form: {
                fields: {
                    lastname: { validators: [required] },
                    firstname: { validators: [required] },
                },
                errors: [],
                values: props.customer || {},
            },
        });
    }
}

export default QuotationFormCustomer;



// WEBPACK FOOTER //
// ./src/components/QuotationForm/QuotationFormCustomer.tsx